import { GitBranch } from "lucide-react";
import { Card } from "@/components/ui/card";

interface BranchSwitchedData {
  branch: string;
  previous_branch?: string | null;
  created?: boolean;
}

interface BranchSwitchedWidgetProps {
  data: BranchSwitchedData;
}

export function BranchSwitchedWidget({ data }: BranchSwitchedWidgetProps) {
  const action = data.created ? "Created and switched to" : "Switched to";

  return (
    <Card variant="default" padding="sm" className="max-w-md animate-slide-up">
      <div className="flex items-center gap-2.5">
        <div className="flex items-center justify-center h-7 w-7 rounded-lg bg-daydra-accent/10 shrink-0">
          <GitBranch size={14} className="text-daydra-accent" />
        </div>
        <div className="min-w-0">
          <p className="text-sm text-daydra-text">
            {action}{" "}
            <span className="font-medium text-daydra-accent">{data.branch}</span>
          </p>
          {data.previous_branch && !data.created && (
            <p className="text-2xs text-daydra-muted mt-0.5">
              from {data.previous_branch}
            </p>
          )}
        </div>
      </div>
    </Card>
  );
}
